// prices.js
export const prices =
{
  "recurring_1": {
    "AED": { "unit_amount": 1399 },
    "AUD": { "unit_amount": 1399 },
    "CAD": { "unit_amount": 1499 },
    "CHF": { "unit_amount": 1999 },
    "EUR": { "unit_amount": 1399 },
    "GBP": { "unit_amount": 1299 },
    "HKD": { "unit_amount": 799 },
    "ILS": { "unit_amount": 1499 },
    "INR": { "unit_amount": 69999 },
    "JPY": { "unit_amount": 79999 },
    "MXN": { "unit_amount": 5699 },
    "NZD": { "unit_amount": 1399 },
    "PLN": { "unit_amount": 1399 },
    "SAR": { "unit_amount": 1499 },
    "SEK": { "unit_amount": 14999 },
    "SGD": { "unit_amount": 1499 },
    "THB": { "unit_amount": 16999 },
    "USD": { "unit_amount": 1499 }
  },
  "recurring_3": {
    "AED": { "unit_amount": 3299 },
    "AUD": { "unit_amount": 2999 },
    "CAD": { "unit_amount": 3499 },
    "CHF": { "unit_amount": 4499 },
    "EUR": { "unit_amount": 2999 },
    "GBP": { "unit_amount": 2999 },
    "HKD": { "unit_amount": 1999 },
    "ILS": { "unit_amount": 3499 },
    "INR": { "unit_amount": 169999 },
    "JPY": { "unit_amount": 189999 },
    "MXN": { "unit_amount": 12999 },
    "NZD": { "unit_amount": 2999 },
    "PLN": { "unit_amount": 2999 },
    "SAR": { "unit_amount": 3499 },
    "SEK": { "unit_amount": 34999 },
    "SGD": { "unit_amount": 3499 },
    "THB": { "unit_amount": 39999 },
    "USD": { "unit_amount": 3499 }
  },
  "recurring_6": {
    "AED": { "unit_amount": 3299 },
    "AUD": { "unit_amount": 4999 },
    "CAD": { "unit_amount": 5999 },
    "CHF": { "unit_amount": 7999 },
    "EUR": { "unit_amount": 4999 },
    "GBP": { "unit_amount": 4999 },
    "HKD": { "unit_amount": 2999 },
    "ILS": { "unit_amount": 5999 },
    "INR": { "unit_amount": 299999 },
    "JPY": { "unit_amount": 319999 },
    "MXN": { "unit_amount": 22599 },
    "NZD": { "unit_amount": 4999 },
    "PLN": { "unit_amount": 4999 },
    "SAR": { "unit_amount": 5999 },
    "SEK": { "unit_amount": 59999 },
    "SGD": { "unit_amount": 5999 },
    "THB": { "unit_amount": 69999 },
    "USD": { "unit_amount": 5999 }
  },
  "recurring_12": {
    "AED": { "unit_amount": 8399 },
    "AUD": { "unit_amount": 7999 },
    "CAD": { "unit_amount": 8999 },
    "CHF": { "unit_amount": 11999 },
    "EUR": { "unit_amount": 7999 },
    "GBP": { "unit_amount": 7499 },
    "HKD": { "unit_amount": 4999 },
    "ILS": { "unit_amount": 8499 },
    "INR": { "unit_amount": 429999 },
    "JPY": { "unit_amount": 469999 },
    "MXN": { "unit_amount": 33999 },
    "NZD": { "unit_amount": 7999 },
    "PLN": { "unit_amount": 7999 },
    "SAR": { "unit_amount": 8999 },
    "SEK": { "unit_amount": 89999 },
    "SGD": { "unit_amount": 8999 },
    "THB": { "unit_amount": 99999 },
    "USD": { "unit_amount": 8999 }
  },
  "one_time_1": {
    "AED": { "unit_amount": 1699 },
    "AUD": { "unit_amount": 1599 },
    "CAD": { "unit_amount": 1799 },
    "CHF": { "unit_amount": 2399 },
    "EUR": { "unit_amount": 1599 },
    "GBP": { "unit_amount": 1499 },
    "HKD": { "unit_amount": 999 },
    "ILS": { "unit_amount": 1799 },
    "INR": { "unit_amount": 84999 },
    "JPY": { "unit_amount": 94999 },
    "MXN": { "unit_amount": 6799 },
    "NZD": { "unit_amount": 1599 },
    "PLN": { "unit_amount": 1599 },
    "SAR": { "unit_amount": 1799 },
    "SEK": { "unit_amount": 17999 },
    "SGD": { "unit_amount": 1799 },
    "THB": { "unit_amount": 19999 },
    "USD": { "unit_amount": 1799 }
  },
  "one_time_3": {
    "AED": { "unit_amount": 3899 },
    "AUD": { "unit_amount": 3699 },
    "CAD": { "unit_amount": 4199 },
    "CHF": { "unit_amount": 5499 },
    "EUR": { "unit_amount": 3699 },
    "GBP": { "unit_amount": 3499 },
    "HKD": { "unit_amount": 2299 },
    "ILS": { "unit_amount": 3999 },
    "INR": { "unit_amount": 199999 },
    "JPY": { "unit_amount": 219999 },
    "MXN": { "unit_amount": 15999 },
    "NZD": { "unit_amount": 3699 },
    "PLN": { "unit_amount": 3699 },
    "SAR": { "unit_amount": 4199 },
    "SEK": { "unit_amount": 41999 },
    "SGD": { "unit_amount": 4199 },
    "THB": { "unit_amount": 47999 },
    "USD": { "unit_amount": 4199 }
  },
  "one_time_6": {
    "AED": { "unit_amount": 6699 },
    "AUD": { "unit_amount": 6299 },
    "CAD": { "unit_amount": 7199 },
    "CHF": { "unit_amount": 9399 },
    "EUR": { "unit_amount": 6299 },
    "GBP": { "unit_amount": 5999 },
    "HKD": { "unit_amount": 3799 },
    "ILS": { "unit_amount": 6899 },
    "INR": { "unit_amount": 339999 },
    "JPY": { "unit_amount": 379999 },
    "MXN": { "unit_amount": 26999 },
    "NZD": { "unit_amount": 6299 },
    "PLN": { "unit_amount": 6299 },
    "SAR": { "unit_amount": 7199 },
    "SEK": { "unit_amount": 71999 },
    "SGD": { "unit_amount": 7199 },
    "THB": { "unit_amount": 79999 },
    "USD": { "unit_amount": 7199 }
  },
  "one_time_12": {
    "AED": { "unit_amount": 10199 },
    "AUD": { "unit_amount": 9699 },
    "CAD": { "unit_amount": 10999 },
    "CHF": { "unit_amount": 14299 },
    "EUR": { "unit_amount": 9699 },
    "GBP": { "unit_amount": 9099 },
    "HKD": { "unit_amount": 5799 },
    "ILS": { "unit_amount": 10499 },
    "INR": { "unit_amount": 499999 },
    "JPY": { "unit_amount": 579999 },
    "MXN": { "unit_amount": 39999 },
    "NZD": { "unit_amount": 9699 },
    "PLN": { "unit_amount": 9699 },
    "SAR": { "unit_amount": 10999 },
    "SEK": { "unit_amount": 109999 },
    "SGD": { "unit_amount": 10999 },
    "THB": { "unit_amount": 123999 },
    "USD": { "unit_amount": 10999 }
  }
};